module.exports = __webpack_public_path__ + "static/img/3.fa454b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3.png
// module id = igRk
// module chunks = 0